module.exports = __webpack_public_path__ + "img/元数据select.66295985.svg";